export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [];

export const dictionary = {
		"/": [11],
		"/admin": [15,[3]],
		"/admin/blacklist-hits": [22,[3,6]],
		"/admin/settings": [23,[3]],
		"/admin/speakers": [24,[3,7]],
		"/admin/speakers/new": [27,[3,7]],
		"/admin/speakers/[speaker_tag]": [25,[3,7,8]],
		"/admin/speakers/[speaker_tag]/edit": [26,[3,7,8]],
		"/admin/streams": [28,[3,9]],
		"/admin/streams/new": [31,[3,9]],
		"/admin/streams/[stream_tag]": [29,[3,9,10]],
		"/admin/streams/[stream_tag]/edit": [30,[3,9,10]],
		"/admin/[tag]": [16,[3,4]],
		"/admin/[tag]/moderation": [17,[3,4]],
		"/admin/[tag]/overlay": [18,[5]],
		"/admin/[tag]/overlay/big": [19,[5]],
		"/admin/[tag]/panel": [20,[3,4]],
		"/admin/[tag]/settings": [21,[3,4]],
		"/leaderboard": [32],
		"/privacy": [33],
		"/submission-terms": [34],
		"/terms": [35],
		"/[tag]": [12,[2]],
		"/[tag]/text": [13,[2]],
		"/[tag]/voice": [14,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';